module.exports = __webpack_public_path__ + "static/img/home-yungis.8928d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-yungis.png
// module id = VSc3
// module chunks = 78